import { featureFlags, cookies } from '@searchspring/snap-toolbox';
const utils = {
    cookies,
};
export class StorageStore {
    constructor(config) {
        this.type = null;
        this.expiration = 31536000000; // one year (ms)
        this.sameSite = 'Lax';
        this.key = 'ss-storage';
        this.cookieDomain = (typeof window !== 'undefined' && window.location.hostname && '.' + window.location.hostname.replace(/^www\./, '')) || undefined;
        this.state = {};
        if (config) {
            if (config.key.trim() !== '') {
                this.key = config.key.trim();
            }
            if (config?.cookie?.expiration) {
                this.expiration = config.cookie.expiration;
            }
            if (config?.cookie?.sameSite) {
                this.sameSite = config.cookie.sameSite;
            }
            switch (config.type) {
                case StorageType.session: {
                    this.type = featureFlags.storage ? config.type : null;
                    if (this.type) {
                        this.state = JSON.parse(window.sessionStorage.getItem(this.key) || '{}');
                        window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
                    }
                    break;
                }
                case StorageType.local: {
                    this.type = featureFlags.storage ? config.type : null;
                    if (this.type) {
                        this.state = JSON.parse(window.localStorage.getItem(this.key) || '{}');
                        window.localStorage.setItem(this.key, JSON.stringify(this.state));
                    }
                    break;
                }
                case StorageType.cookie: {
                    if (featureFlags.cookies) {
                        this.type = config.type;
                        const data = utils.cookies.get(this.key);
                        if (data) {
                            this.state = JSON.parse(data);
                        }
                    }
                    break;
                }
                default: {
                    this.type = StorageType.memory;
                }
            }
        }
    }
    set(path, value) {
        const paths = path?.split('.');
        let location = this.state;
        paths?.forEach((p, i) => {
            const leaf = i == paths.length - 1;
            if (leaf) {
                location[p] = value;
            }
            else {
                location = location[p] = location[p] || {};
            }
        });
        switch (this.type) {
            case StorageType.session:
                window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
                break;
            case StorageType.local:
                window.localStorage.setItem(this.key, JSON.stringify(this.state));
                break;
            case StorageType.cookie:
                utils.cookies.set(this.key, JSON.stringify(this.state), this.sameSite, this.expiration, this.cookieDomain);
                break;
        }
    }
    get(path) {
        switch (this.type) {
            case StorageType.session:
                const sessionData = window.sessionStorage.getItem(this.key);
                this.state = sessionData ? JSON.parse(sessionData) : {};
                break;
            case StorageType.local:
                const localData = window.localStorage.getItem(this.key);
                this.state = localData ? JSON.parse(localData) : {};
                break;
            case StorageType.cookie:
                const data = utils.cookies.get(this.key);
                if (data) {
                    this.state = JSON.parse(data) || {};
                }
                break;
        }
        const paths = path?.split('.');
        if (!paths?.length)
            return undefined;
        let value = this.state;
        for (const p of paths) {
            if (value && typeof value[p] != 'undefined') {
                value = value[p];
            }
            else {
                value = {};
                return;
            }
        }
        return value;
    }
    clear() {
        switch (this.type) {
            case StorageType.session:
                window.sessionStorage.removeItem(this.key);
                break;
            case StorageType.local:
                window.localStorage.removeItem(this.key);
                break;
            case StorageType.cookie:
                utils.cookies.unset(this.key, this.cookieDomain);
                break;
        }
        this.state = {};
    }
}
export var StorageType;
(function (StorageType) {
    StorageType["session"] = "session";
    StorageType["local"] = "local";
    StorageType["cookie"] = "cookie";
    StorageType["memory"] = "memory";
})(StorageType || (StorageType = {}));
